import React from 'react';
import { Outlet } from 'react-router-dom';

import { Heading } from '@eluve/components';
import { TabNav } from '@eluve/smart-blocks';

export const AssetDeletionDash: React.FC = () => {
  return (
    <div>
      <div className="my-2 py-2">
        <Heading>Asset Deletion Dash</Heading>
      </div>

      <TabNav
        tabs={[
          {
            name: 'Submit New Request',
            link: 'new',
          },
          {
            name: 'Jobs History',
            link: 'history',
          },
        ]}
      />
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
};
